import React from 'react'
import ChevronIcon from './ChevronIcon'
import { format } from 'date-fns'

import { ReactComponent as GlassesIcon } from 'assets/svg/glasses.svg'
import { ReactComponent as SunglassesIcon } from 'assets/svg/sunglasses.svg'

import { Border, Color, Gap, NINAL_SHORTER_NAME, Responsive, SERVICE_STATE_LIST, Size } from 'const'
import styled from 'styled-components'
import ProductBox from './ProductBox'
import { useHistory } from 'react-router-dom'
import _ from 'lodash'

const Contract = ({ contract }) => {
  const history = useHistory()
  const {
    dev_service_name: serviceName,
    ninal_subscription_application: subscription,
    getContractItems,
    dev_state_no: stateNo,
    PRODUCT_CLASSIFICATION,
    credit_card: creditCard,
  } = contract
  const { new_item: newItem, will_return_item: willReturnItem, user } = subscription
  const { firstname, lastname } = user
  const fullname = `${lastname} ${firstname}`
  const closeDateText = (() => {
    const closeDate = subscription.dev_close_date ? subscription.dev_close_date : subscription.dev_will_close_date

    if (closeDate) return format(new Date(closeDate), 'yyyy年M月d日')

    return '-'
  })()
  const subscriptionAvailable = _.isNumber(subscription.available_num) ? subscription.available_num : -1
  const isCreditCardExist = !_.isEmpty(creditCard) && !!creditCard.card_no
  const newFrame = newItem.frames?.length > 0 ? newItem.frames[0] : {}
  const newLensRight =
    newItem.lenses?.find((lense) => {
      return lense.dev_rl === '右'
    }) || {}
  const newLensLeft =
    newItem.lenses?.find((lense) => {
      return lense.dev_rl === '左'
    }) || {}

  const newItemArray = _.flatMap(_.values(newItem))
  const willReturnItemArray = _.flatMap(_.values(willReturnItem))
  const isItemsExist = newItemArray.length > 0 || willReturnItemArray.length > 0

  const isNewItemsExist = !_.isEmpty(newFrame) || !_.isEmpty(newLensRight) || !_.isEmpty(newLensLeft)

  const subscriptionAvailableText =
    isCreditCardExist && isNewItemsExist && subscriptionAvailable >= 0 ? `${subscriptionAvailable}回` : '-'

  const contractItems = getContractItems(subscription).map((item) => {
    if (item.dev_product_classification === PRODUCT_CLASSIFICATION['フレーム']) {
      item.icon = <GlassesIcon />
      item.label = 'フレーム'
    } else if (item.dev_product_classification === PRODUCT_CLASSIFICATION['サングラス']) {
      item.icon = <SunglassesIcon />
      item.label = 'サングラス'
    }

    return item
  })

  const mainItem = contractItems.find((item) => item.icon)

  const renderContractSummaryItems = contractItems.length > 0 && stateNo !== 277670005 && (
    <ContractSummary>
      {!_.isEmpty(mainItem) && (
        <ProductBox
          svg={mainItem.icon}
          info={mainItem.label}
          text={`${mainItem.dev_brand} ${mainItem.abbreviation || ''}`}
        />
      )}
    </ContractSummary>
  )

  const navigateContractDetail = () => history.push(`/service/${contract.dev_contractid}`)

  const serviceState = SERVICE_STATE_LIST[stateNo]

  const shorterServiceName = NINAL_SHORTER_NAME[serviceName]

  const subscriptionAvailableShow =
    shorterServiceName !== 'NINAL step' && (stateNo === 277670000 || (stateNo === 277670003 && isItemsExist))

  const closeDateShow = ![277670006, 277670007].includes(stateNo)

  return (
    <ContractBox onClick={navigateContractDetail} role="button" tabIndex={0}>
      <ContractHeader>
        <ContractHeaderWrapper>
          <ContractStatus color={serviceState.color} bg={serviceState.bg}>
            {serviceState.title}
          </ContractStatus>
          <ContractTitleWrapper>
            <ContractTitle>{shorterServiceName}</ContractTitle>
            <ContractNo>契約番号：{subscription.dev_contract_no}</ContractNo>
          </ContractTitleWrapper>
        </ContractHeaderWrapper>
        <ContractNavigation>
          <ChevronIcon />
        </ContractNavigation>
      </ContractHeader>
      <ContractBody>
        {renderContractSummaryItems}
        <ContractInfo>
          <ContractRow>
            <ContractInfoColumnTitle>ご利用者氏名</ContractInfoColumnTitle>
            <ContractInfoColumnContent>{fullname}</ContractInfoColumnContent>
          </ContractRow>

          {closeDateShow && (
            <ContractRow>
              <ContractInfoColumnTitle>契約終了日</ContractInfoColumnTitle>
              <ContractInfoColumnContent>{closeDateText}</ContractInfoColumnContent>
            </ContractRow>
          )}

          {subscriptionAvailableShow && (
            <ContractRow>
              <ContractInfoColumnTitle>残りの交換回数</ContractInfoColumnTitle>
              <ContractInfoColumnContent>{subscriptionAvailableText}</ContractInfoColumnContent>
            </ContractRow>
          )}
        </ContractInfo>
      </ContractBody>
    </ContractBox>
  )
}

const ContractBox = styled.div`
  background: ${Color.BACKGROUND.BASE};
  border: 1px solid ${Color.BORDER.MENU};
  border-radius: ${Border.MENU.RADIUS};
  padding: 10px 20px 30px;
  display: flex;
  flex-direction: column;
  gap: ${Gap.XL};
  text-decoration: none;
  cursor: pointer;
`

const ContractHeader = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${Color.BORDER.MENU};
  gap: ${Gap.LG};
  padding: 16px 0;
`

const ContractHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Gap.LG};
  flex: 1;
  @media screen and (max-width: ${Responsive.XS.DOWN}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const ContractStatus = styled.div`
  border: 1px solid ${Color.FONT.NORMAL};
  min-width: 90px;
  padding: 4px;
  text-align: center;
  font-weight: 700;
  font-size: ${Size.FONT.NORMAL};
  ${(props) => props.bg && `background: ${props.bg};`}
  ${(props) => props.color && `color: ${props.color};`}
`

const ContractTitleWrapper = styled.div`
  flex: 1;
`

const ContractTitle = styled.div`
  flex: 1;
  font-size: ${Size.FONT.LG};
  font-weight: bold;
`

const ContractNo = styled.div`
  font-size: ${Size.FONT.LG};
  font-weight: 500;

  @media screen and (max-width: ${Responsive.MD.DOWN}px) {
    font-size: ${Size.FONT.BIG};
  }
`

const ContractNavigation = styled.div``

const ContractBody = styled.div`
  display: flex;
  flex-direction: column;
`

const ContractSummary = styled.div`
  display: grid;
  gap: ${Gap.MD};
  grid-template-columns: repeat(2, 1fr);
  padding-bottom: ${Gap.XXL};

  @media screen and (max-width: ${Responsive.XS.DOWN}px) {
    grid-template-columns: 1fr;
  }
`

const ContractInfo = styled.div`
  display: table;
  font-size: ${Size.FONT.NORMAL};
  font-weight: 500;
`

const ContractRow = styled.div`
  display: table-row;
`

const ContractInfoColumnTitle = styled.div`
  display: table-cell;
  width: 120px;
  font-size: ${Size.FONT.BIG};
`

const ContractInfoColumnContent = styled.div`
  display: table-cell;
  padding: 4px 16px;
  font-size: ${Size.FONT.BIGGER};
`

export default Contract
